export interface Product {
  name: string;
  description: { ro: string; en: string };
  image: string;
  type: "electric" | "servo-hydraulic" | "robot" | "auxiliary";
  url: string;
}

export interface CategoryData {
  titleKey: string;
  descKey: string;
  products: Product[];
}

export const categoryProducts: Record<string, CategoryData> = {
  "masini-de-injectie": {
    titleKey: "nav.injectionMachines",
    descKey: "equipment.injectionDesc",
    products: [
      {
        name: "EcoPower 55 – 550 t",
        description: {
          ro: "EcoPower: economie de energie, curată, compactă. Mașina complet electrică, cu forțe de strângere de la 55 la 550 t, combină eficiența cu precizia.",
          en: "The EcoPower: energy saving, clean, compact. The all-electric EcoPower, with clamping forces from 55 to 550 t, combines efficiency with precision.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2022-12/ecopower_110_totale-schraeg_2022-08-witt_web.jpg.webp?itok=ltyWrs81",
        type: "electric",
        url: "https://www.wittmann-group.com/en/ecopower-55-550-t",
      },
      {
        name: "EcoPower Xpress 160 – 500 t",
        description: {
          ro: "Mașini de înaltă performanță pentru timpi de ciclu extrem de scurți, cu forțe de strângere de la 160 la 500 t.",
          en: "High-performance machinery for extremely short cycle times with clamping forces ranging from 160 to 500 t.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2022-12/ecopower_xpress_160_totale-schraeg_2022-08-witt_web.jpg.webp?itok=-b4NJjGV",
        type: "electric",
        url: "https://www.wittmann-group.com/en/ecopower-xpress-160-500-t",
      },
      {
        name: "MicroPower 15 t",
        description: {
          ro: "MicroPower stabilește standarde noi. Se caracterizează prin eficiență ridicată a costurilor, precizie, flexibilitate și ușurință în utilizare.",
          en: "The MicroPower is setting benchmarks. It is characterized by a high degree of cost-efficiency, precision, flexibility and user-friendliness.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2022-12/micropower-b8-layer_2016-08_02_witt_web.jpg.webp?itok=SbJLKm69",
        type: "electric",
        url: "https://www.wittmann-group.com/en/micropower-15-t",
      },
      {
        name: "MacroPower 400 – 2200 t",
        description: {
          ro: "MacroPower este cel mai mare model de tonaj din PowerSeries: compact, modular, precis.",
          en: "The MacroPower is the largest tonnage machine model of the PowerSeries: compact, modular, precise.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2022-12/macropower_650_totale-schraeg_01_2022-08-witt_web.jpg.webp?itok=pwRnGXbo",
        type: "servo-hydraulic",
        url: "https://www.wittmann-group.com/en/macropower-400-2200-t",
      },
      {
        name: "SmartPower B8X 38 – 400 t",
        description: {
          ro: "Mașinile servo-hidraulice compacte cu sistem de acționare inteligent și economic. Precizie, eficiență și utilizare nelimitate.",
          en: "The compact servo hydraulic machines with intelligent, energy-saving drive system. Unlimited in precision, efficiency and usability.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2022-12/smartpower-b8-schraeg_2016-05_01-witt_rot_web.jpg.webp?itok=lH6zP21e",
        type: "servo-hydraulic",
        url: "https://www.wittmann-group.com/en/smartpower-38-400-t",
      },
      {
        name: "CM 40 – 80 t",
        description: {
          ro: "Mașinile CM, CM S și CM R fără coloane se caracterizează prin design compact cu dimensiuni exterioare reduse pentru producție economică.",
          en: "The CM, CM S and CM R machines without tie bars are characterized by compact design with small outer dimensions for space saving production.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2022-12/cm_40-210_wefo-tec_ganz-schraeg_2018_04-12_02_2022-04-witt_web.jpg.webp?itok=V2XV8zyk",
        type: "servo-hydraulic",
        url: "https://www.wittmann-group.com/en/vertical-machines-cm-cm-r-cm-s-vm-vm-r-vpower",
      },
      {
        name: "VM R 40 – 300 t",
        description: {
          ro: "Seria de mașini cu masă rotativă este disponibilă cu forțe de strângere de la 40 la 300 t și mese rotative cu diametru de la 752 la 1755 mm.",
          en: "The rotary table machine series is available with clamping force sizes from 40 to 300 t and rotary tables ranging from 752 to 1755 mm in diameter.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2022-12/vm_r_110-210-r1280_totale-schraeg_2022-08-witt_web.jpg.webp?itok=lGIwFbMp",
        type: "servo-hydraulic",
        url: "https://www.wittmann-group.com/en/vertical-machines-cm-cm-r-cm-s-vm-vm-r-vpower",
      },
      {
        name: "VM 60 – 200 t",
        description: {
          ro: "Seria VM permite o producție flexibilă, automatizată, cu precizie maximă.",
          en: "The VM series enables a flexible, automated production with ultimate precision.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2022-12/vm_100-130_ganz-schraeg_2018_04-12_04-witt_web.jpg.webp?itok=MVGzy-97",
        type: "servo-hydraulic",
        url: "https://www.wittmann-group.com/en/vertical-machines-cm-cm-r-cm-s-vm-vm-r-vpower",
      },
      {
        name: "VPower 120 – 300 t R",
        description: {
          ro: "Mașina flexibilă VPower R cu masă rotativă este disponibilă cu forțe de strângere de la 120 la 300 t și diametre ale mesei rotative de 1300, 1600 și 2000 mm.",
          en: "The flexible VPower R rotary table machine is available with clamping force sizes from 120 to 300 t and rotary table diameters of 1300 mm, 1600 mm and 2000 mm.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2022-12/vpower_120_r1300_horizontal_schraeg_totale_2019_07-11_2022_04-witt_web.jpg.webp?itok=rFGlOQj-",
        type: "servo-hydraulic",
        url: "https://www.wittmann-group.com/en/vertical-machines-cm-cm-r-cm-s-vm-vm-r-vpower",
      },
    ],
  },
  roboti: {
    titleKey: "nav.robots",
    descKey: "equipment.robotsDesc",
    products: [
      {
        name: "W9 and WX Series",
        description: {
          ro: "Soluții robotice flexibile pentru orice scop. Roboți liniari versatili pentru o gamă largă de aplicații.",
          en: "Flexible Robot Solutions for Every Purpose. Versatile linear robots for a wide range of applications.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2020-10/robot_wx153_total_2020_09_web.jpg.webp?itok=vAQ3X6R7",
        type: "robot",
        url: "https://www.wittmann-group.com/en/w9-and-wx-series",
      },
      {
        name: "Sonic Series",
        description: {
          ro: "Seria de roboți ultra-rapizi. Performanță maximă pentru timpi de ciclu extrem de scurți.",
          en: "Ultra-Highspeed Robot Series. Maximum performance for extremely short cycle times.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2020-10/robot_sonic143_total_2019_09_web.jpg.webp?itok=sqN4pl4e",
        type: "robot",
        url: "https://www.wittmann-group.com/en/sonic-series",
      },
      {
        name: "Primus Series",
        description: {
          ro: "Soluții robotice eficiente din punct de vedere al costurilor. Performanță fiabilă la un preț accesibil.",
          en: "Cost-efficient Robot Solutions. Reliable performance at an affordable price.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2020-10/robot_primus48t_total_2020_09_web.jpg.webp?itok=ifQpTB9P",
        type: "robot",
        url: "https://www.wittmann-group.com/en/primus-series",
      },
      {
        name: "Sprue Pickers",
        description: {
          ro: "Pentru extragerea tuturor tipurilor de culeuri. Soluții simple și eficiente pentru automatizarea de bază.",
          en: "For the Removal of All Kinds of Sprues. Simple and efficient solutions for basic automation.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2020-10/robot_wp80_total_2014_09_web.jpg.webp?itok=DjlEi3yY",
        type: "robot",
        url: "https://www.wittmann-group.com/en/sprue-pickers",
      },
      {
        name: "Customized Solutions",
        description: {
          ro: "Soluții speciale pentru automatizare și celule de producție. Proiecte personalizate pentru cerințe complexe.",
          en: "Special Solutions for Automation and Production Cells. Custom projects for complex requirements.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2020-10/robot_tandem_imm-2_2020_10_web.jpg.webp?itok=v7sJd-_S",
        type: "robot",
        url: "https://www.wittmann-group.com/en/customized-solutions",
      },
    ],
  },
  auxiliare: {
    titleKey: "nav.auxiliaries",
    descKey: "equipment.auxiliariesDesc",
    products: [
      {
        name: "Blenders",
        description: {
          ro: "Dozatoare gravimetrice și echipamente de dozare volumetrică pentru amestecarea precisă a materialelor plastice.",
          en: "Gravimetric Blenders and Volumetric Dosing Equipment for precise plastics material blending.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2025-03/blending_teaser_web_2025_03.jpg.webp?itok=BrQlSuwd",
        type: "auxiliary",
        url: "https://www.wittmann-group.com/en/blenders",
      },
      {
        name: "Vacuum Loaders",
        description: {
          ro: "Unități de transport, controlere și accesorii pentru alimentarea eficientă cu material.",
          en: "Conveying Units, Controls, and Accessories for efficient material feeding.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2020-11/conveying_feedmax_group_2017_01_web_0.jpg.webp?itok=a3a3Iqbz",
        type: "auxiliary",
        url: "https://www.wittmann-group.com/en/vacuum-loaders",
      },
      {
        name: "Dryers",
        description: {
          ro: "Uscătoare de material și buncăre de uscare pentru pregătirea optimă a granulelor plastice.",
          en: "Material Dryers and Drying Hoppers for optimal plastic granule preparation.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2025-03/dryers_teaser_web_2025_03.jpg.webp?itok=gu5yXh-6",
        type: "auxiliary",
        url: "https://www.wittmann-group.com/en/dryers",
      },
      {
        name: "Granulators",
        description: {
          ro: "Granulatoare lângă mașină și granulatoare centrale pentru reciclarea eficientă a materialelor.",
          en: "Beside-the-press and Central Granulators for efficient material recycling.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2025-03/granulators_teaser_web_2025_03_0.jpg.webp?itok=YrxQ6Ejn",
        type: "auxiliary",
        url: "https://www.wittmann-group.com/en/granulators",
      },
      {
        name: "Temperature Controllers",
        description: {
          ro: "Control superior al temperaturii matriței pentru calitate optimă a pieselor injectate.",
          en: "Superior Mold Temperature Control for optimal injected part quality.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2025-03/temperature_teaser_web_2025_03.jpg.webp?itok=dyt4qR9D",
        type: "auxiliary",
        url: "https://www.wittmann-group.com/en/temperature-controllers",
      },
      {
        name: "Water Flow Regulators",
        description: {
          ro: "Regulatoare de debit de apă de top mondial pentru controlul precis al răcirii matrițelor.",
          en: "The World's Leading Water Flow Regulators for precise mold cooling control.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/teaser_image_/public/2025-03/waterflow_teaser_web_2025_03.jpg.webp?itok=CwWrBYP1",
        type: "auxiliary",
        url: "https://www.wittmann-group.com/en/water-flow-regulators",
      },
    ],
  },
  "sisteme-centralizate": {
    titleKey: "nav.centralSystems",
    descKey: "equipment.centralDesc",
    products: [
      {
        name: "Central Material Loaders – Feedmax Series",
        description: {
          ro: "Încărcătoare centrale din seria Feedmax, construite pentru funcționalitate maximă și aplicații solicitante. Design modular pentru ajustare individuală.",
          en: "Feedmax series loaders built for highest functionality and demanding applications. Modular design for specific adjustment to individual requirements.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/max_1300x1300/public/2020-11/conveying_feedmax_group_2017_01_web_0.jpg.webp?itok=3N0p7vJS",
        type: "auxiliary",
        url: "https://www.wittmann-group.com/en/central-systems",
      },
      {
        name: "Drymax Battery Dryers 180 – 1200",
        description: {
          ro: "Uscătoare cu baterie echipate cu două paturi desicante pentru aer de proces continuu și calitate constantă a aerului uscat.",
          en: "Battery dryers equipped with two desiccant beds providing continuous process air and constant dry air quality for perfect plastic resin drying.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/max_1300x1300/public/2020-11/drying_drymax_group_2020_11_web.jpg.webp?itok=FSXJN4Rm",
        type: "auxiliary",
        url: "https://www.wittmann-group.com/en/central-systems",
      },
      {
        name: "M8 Network Control System",
        description: {
          ro: "Sistem de control pentru administrarea configurațiilor de rețea medii și complexe, cu până la 320 de participanți, ecran tactil de înaltă rezoluție.",
          en: "Network control system for managing medium to complex configurations with up to 320 participants, featuring a high-resolution touchscreen.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/max_1300x1300/public/2020-11/centralmh_m8control_total_2020_10_web.jpg.webp?itok=wqyI-NN0",
        type: "auxiliary",
        url: "https://www.wittmann-group.com/en/central-systems",
      },
      {
        name: "Codemax – RFID Coupling Station",
        description: {
          ro: "Stație de cuplare codificată care evită conectarea eronată a materialului greșit prin tehnologie RFID cu identificator pe 64 de biți.",
          en: "Coded coupling station that prevents erroneous material connections using RFID technology with a 64-bit identifier.",
        },
        image: "https://www.wittmann-group.com/sites/default/files/styles/max_1300x1300/public/2022-12/centralmh_couplingstation_detail_2018_01_web.jpg.webp?itok=2MeNbyBm",
        type: "auxiliary",
        url: "https://www.wittmann-group.com/en/central-systems",
      },
    ],
  },
};
